import { getPlaceholder } from '@helpers/placeholder';
import React from 'react';
import S from '../../UmbracoForm.styles';
const Textfield = React.forwardRef(({ id, field, dirty, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error },
        React.createElement(S.Label, { htmlFor: id ?? field.alias },
            field.caption,
            field.required ? '*' : null),
        React.createElement(S.Input, { ref: ref, id: id ?? field.alias, type: field.settings?.fieldType ?? 'text', placeholder: getPlaceholder(field), defaultValue: field.settings?.defaultValue ?? '', autoComplete: field.settings?.autocompleteAttribute ? field.settings.autocompleteAttribute : undefined, required: field.required, maxLength: field.settings?.maximumLength ? Number(field.settings.maximumLength) : undefined, ...otherProps }),
        field.helpText && React.createElement(S.HelpText, null, field.helpText),
        error && React.createElement(S.Error, null, error.message)));
});
Textfield.displayName = 'Textfield';
export default Textfield;
